<template>
    <div class="main">
    </div>
</template>
<script>
import * as mutations from '@/graphql/mutations'
import { API, graphqlOperation } from 'aws-amplify'
import axios from 'axios'
export default {
  name: 'paymentCard',
  data () {
    return {
      key: '',
      paymentInfo: {}
    }
  },
  mounted () {
    console.log('mounted::', this.$options.name)
    this.$store.state.isLoading = true
    this.insertOrder()
  },
  methods: {
    async insertOrder () {
      const vm = this
      vm.key = vm.$route.query.seq
      !vm.$empty(vm.$route.query.eventSeq) && await vm.setKey(vm.$route.query.eventSeq)
      vm.paymentInfo = JSON.parse(localStorage.getItem(`${vm.key}_paymentCard`))
      if (vm.$empty(vm.paymentInfo)) {
        vm.moveRouter('orderProcessList')
      }
      localStorage.removeItem(`${vm.key}_paymentCard`)
      // 결제상품 장바구니 비우기
      localStorage.removeItem(vm.key)
      localStorage.setItem(vm.key, JSON.stringify(vm.paymentInfo.productBasket))
      vm.key += '_paymentCard'
      var order = await API.graphql(graphqlOperation(
        mutations.createSeryOrderInfo, {
          input: vm.paymentInfo.obj
        })
      )
      if (!vm.$empty(order)) {
        vm.paymentInfo.obj.orderNo = vm.paymentInfo.orderNo
        var updateObj = {
          orderSeq: vm.paymentInfo.obj.orderSeq,
          storeSeq: vm.paymentInfo.obj.storeSeq,
          userSeq: vm.paymentInfo.obj.userSeq,
          deliveryInfo: vm.paymentInfo.obj.deliveryInfo,
          orderDate: vm.paymentInfo.obj.orderDate,
          paymentType: vm.paymentInfo.obj.paymentType,
          deliveryType: vm.paymentInfo.obj.deliveryType,
          memo: vm.paymentInfo.obj.memo,
          orderNo: vm.paymentInfo.obj.orderNo,
          orderPrice: vm.paymentInfo.obj.orderPrice,
          deliveryPrice: vm.paymentInfo.obj.deliveryPrice,
          orderState: 1,
          deliveryName: vm.paymentInfo.obj.deliveryName,
          deliveryCode: vm.paymentInfo.obj.deliveryCode,
          deliveryNo: vm.paymentInfo.obj.deliveryNo,
          receiveCode: vm.paymentInfo.obj.receiveCode,
          bookingTime: vm.paymentInfo.obj.bookingTime,
          detailInfo: vm.paymentInfo.obj.detailInfo,
          deliveryTime: vm.paymentInfo.obj.deliveryTime,
          doneTime: vm.paymentInfo.obj.doneTime,
          riderId: vm.paymentInfo.obj.riderId,
          cancelReason: vm.paymentInfo.obj.cancelReason,
          // storeName: vm.paymentInfo.obj.storeName,
          cancelReasonDetail: vm.paymentInfo.obj.cancelReasonDetail
        }
        // console.log('updateObj:::', updateObj)
        await API.graphql(graphqlOperation(
          mutations.updateSeryOrderInfo, {
            input: updateObj
          })
        )
        // console.log('success input order:::', update)
        vm.$store.commit('getBasketCnt', JSON.stringify(vm.paymentInfo.productBasket))
        if (!vm.$empty(vm.$route.query.eventSeq)) {
          axios({
            method: 'patch',
            url: `${process.env.API}/smart-view-event/orderCount/${vm.$route.query.eventSeq}`
          }).then((response) => {
            console.log(response)
          })
        }
        // 주문내용 라이브채팅 추가
        const addressStringArray = vm.paymentInfo.deliveryInfo.receiveAddress.split(' ')
        const data = {
          storeSeq: vm.$route.query.seq,
          sK: `CHAT#LIVE#${vm.$dayjs().format('YYYYMMDDHHmmss')}`,
          datetime: vm.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
          contents: `${vm.paymentInfo.deliveryInfo.receivePhone2.substr(-4)}님이 주문했어요.(${addressStringArray[2]})`,
          name: '주문',
          type: 'live_order',
          roomType: 'live'
        }
        await API.graphql({
          query: mutations.createStoreQnaInfoTable,
          variables: { input: data }
        })
        // sendTelegram()
        // sendPush()
        vm.$store.state.isLoading = false
        vm.moveRouter('orderProcessList')
        // 주문접수내용 텔레그램 추가
        // var sendTele = await sendTelegram()
        // if (sendTele === 'success') {
        //   var push = await sendPush()
        //   if (push.status === 200) {
        //     vm.$store.state.isLoading = false
        //     alert('주문이 접수되었습니다.')
        //     vm.moveRouter('orderProcessList')
        //   } else {
        //     vm.$store.state.isLoading = false
        //     alert('주문이 접수되었습니다.')
        //     vm.moveRouter('orderProcessList')
        //   }
        // } else {
        //   console.log('sendTele err:::', sendTele)
        //   var push2 = await sendPush()
        //   if (push2.status === 200) {
        //     vm.$store.state.isLoading = false
        //     alert('주문이 접수되었습니다.')
        //     vm.moveRouter('orderProcessList')
        //   } else {
        //     console.log('pushData err:::', push2)
        //     vm.$store.state.isLoading = false
        //     alert('주문이 접수되었습니다.')
        //     vm.moveRouter('orderProcessList')
        //   }
        // }
      }
      // function sendTelegram () {
      //   return new Promise((resolve, reject) => {
      //     vm.$axios({
      //       method: 'get',
      //       url: `https://n18xzda2u4.execute-api.ap-northeast-2.amazonaws.com/prod/new-order`,
      //       params: {
      //         storeName: `[WEB]${vm.$store.state.storeInfo.STORE_NAME}`,
      //         storeSeq: vm.$store.state.storeInfo.STORE_SEQ,
      //         orderDate: vm.paymentInfo.obj.orderDate,
      //         msg: `주문이 접수 되었습니다.|- 주문번호 : ${vm.paymentInfo.obj.orderNo}|- 주문일시 : ${vm.$dayjs(vm.paymentInfo.obj.orderDate).format('YYYY-MM-DD HH:mm:ss')}|- 주문금액 : ${vm.numberWithCommas(vm.paymentInfo.obj.orderPrice)}`
      //       }
      //     })
      //       .then((response) => {
      //         resolve(response.data)
      //       })
      //   })
      // }
      // function sendPush () {
      //   return new Promise((resolve, reject) => {
      //     vm.$axios({
      //       method: 'post',
      //       url: 'https://www.sery.co.kr/store/v4/' + vm.$store.state.storeInfo.STORE_SEQ + '/orders',
      //       data: {
      //         deliveryInfo: {
      //           failCode: '',
      //           result: ''
      //         },
      //         failCode: '',
      //         memo: `주문이 접수 되었습니다.|- 주문번호 : ${vm.paymentInfo.obj.orderNo}|- 주문일시 : ${vm.$dayjs(vm.paymentInfo.obj.orderDate).format('YYYY-MM-DD HH:mm:ss')}|- 주문금액 : ${vm.numberWithCommas(vm.paymentInfo.obj.orderPrice)}`,
      //         orderDetails: [],
      //         orderNo: vm.paymentInfo.obj.orderNo,
      //         result: '',
      //         storeInfo: {
      //           endPuter: 10,
      //           failCode: '',
      //           heloFriendCount: 0,
      //           result: '',
      //           staffCount: 0,
      //           startPuter: 0,
      //           storeDelivery: {
      //             deliveryCost: 0,
      //             minPromoCost: 0
      //           }
      //         },
      //         storeSeq: vm.$store.state.storeInfo.STORE_SEQ
      //       }
      //     })
      //       .then((response) => {
      //         resolve(response)
      //       })
      //   })
      // }
    },
    setKey (eventSeq) {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.key = `${vm.$route.query.seq}_${eventSeq}`
        resolve('success')
      })
    },
    numberWithCommas (x, flag) {
      if (flag === 0) {
        if (!x) {
          return '0'
        } else if (x === 0 || x === '0') {
          return ''
        } else {
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
      } else {
        if (!x) {
          return '0원'
        } else if (x === 0 || x === '0') {
          return ''
        } else {
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원'
        }
      }
    }
  }
}
</script>

<style scoped>
.main {
   width: 100%;
   height: 100%;
   color:#e0e0e0;
   min-width:400px;
   margin:auto;
  }
  .innerMain{
    width:100%;
    height: -moz-calc(100vh - 100px);
    height:-webkit-calc(100vh - 100px);
    height:calc(100vh - 100px);
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/productBasket/paymentCard.vue